export default __webpack_public_path__ + "static/media/flag.050f03d5.svg";